import { BaseError } from '../../errors/baseError';

export class Ipv4SubnetStringError extends BaseError {
  constructor(value: string) {
    super(
      'ipv4_subnet_string_string',
      `Expected an ipv4 subnet string, got ${value}`,
    );
  }
}
